package com.mgacreative.hotel.domain.repository

import com.mgacreative.hotel.core.network.SupabaseNetworkClient
import com.mgacreative.hotel.domain.model.Guest
import io.github.jan.supabase.postgrest.postgrest

interface GuestRepository {
    suspend fun createGuest(guest: Guest): Guest?
    suspend fun updateGuest(guest: Guest): Guest?
}

class GuestRepositoryImpl(private val networkClient: SupabaseNetworkClient) : GuestRepository {
    override suspend fun createGuest(guest: Guest): Guest? {
        return try {
            networkClient.client.postgrest["guests"]
                .insert(guest) {
                    select()
                }
                .decodeSingleOrNull<Guest>()
        } catch (e: Exception) {
            println("GUEST_REPO_ERROR: ${e.message}")
            e.printStackTrace()
            networkClient.handleError(e)
            null
        }
    }
    
    override suspend fun updateGuest(guest: Guest): Guest? {
        return try {
            networkClient.client.postgrest["guests"]
                .update(guest) {
                    filter { eq("id", guest.id ?: "") }
                    select()
                }
                .decodeSingleOrNull<Guest>()
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            null
        }
    }
}
